// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__JGLN5","productName":"Table_productName__Z4tDS"};